import _ from "lodash";
import { ReactElement } from "react";

import { palette } from "~frontend/theme";

import { Chart } from "./Chart";
import { ChartContainer } from "./ChartContainer";
import { Month } from "./monthlyBuckets";
import { maybeNumberToPercentage } from "./numbers";

type Data = {
  month: Month;
  linkConversionRate?: number;
}[];

export function LinkConversionRateChart({
  data,
}: {
  data: Data | null;
}): ReactElement {
  return (
    <ChartContainer
      title="Link Conversion"
      loading={!data}
      downloadableRows={data?.map(r => ({
        month: r.month.toString(),
        linkConversionRate: (r.linkConversionRate ?? 0).toFixed(4),
      }))}
      downloadFileName="linkConversion.csv"
      empty={data?.length === 0}
    >
      <Chart
        data={data ?? []}
        series={[
          {
            type: "line",
            yAxisId: "conversionRate",
            label: "Link Conversion",
            color: palette.blue,
            getValue: d => d.linkConversionRate ?? null,
          },
        ]}
        getXAxisValue={data => data.month.toString()}
        xAxisLabel="Campaign Start Month"
        xAxisTicks={4}
        yAxes={{
          conversionRate: {
            formatValue: value => maybeNumberToPercentage(value)!,
            formatTick: value => maybeNumberToPercentage(value)!,
            label: "Link Conversion",
            width: 60,
          },
        }}
        height={280}
      />
    </ChartContainer>
  );
}
